import { getErrorMonitoringProvider } from "@stadium/services/error-reporting/provider";
import { captureException as sentryCaptureException } from "@stadium/services/sentry-nextjs";
import { reportAppError as datadogReportAppError } from "@stadium/services/datadog-nextjs";

/**
 * Report an error from a Next.js error boundary (error.tsx / global-error).
 * Provider-specific: Sentry captureException, Datadog addNextjsError.
 */
export const reportAppError = (error, context) => {
  const provider = getErrorMonitoringProvider();

  if (provider === "datadog") {
    return datadogReportAppError(error, context);
  }

  if (provider === "sentry") {
    return sentryCaptureException(error, context);
  }

  return null;
};
